//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "App",
  data() {
    return {};
  },
  created: function () {
    // console.log(this.$router);
  },
};



// WEBPACK FOOTER //
// ./src/App.vue